import { render, staticRenderFns } from "./table-primary.vue?vue&type=template&id=c53aa618&scoped=true&"
import script from "./table-primary.vue?vue&type=script&lang=js&"
export * from "./table-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53aa618",
  null
  
)

export default component.exports